import React from 'react'
import { connect } from 'react-redux'
import { Box, Paper } from '@mui/material'
import classNames from 'classnames'
import Topbar from './topbar/Topbar'
import RoomsTable from './RoomsTable'
import Note from './note/Note'
import './Grid.scss'

const Grid = ({ browser: { mobile } }) => {
  return (
    <Box className={classNames('grid-container', { mobile })}>
      <Box className="grid-topbar">
        <Topbar className="topbar" />
      </Box>
      <Paper className="grid-left">
        <RoomsTable />
      </Paper>
      <Paper className="grid-right">
        <Note />
      </Paper>
    </Box>
  )
}

export default connect(
  state => ({
    browser: state.browser
  })
)(Grid)
